const types = {
  restrict: {
    modalTitle: 'AMsuite+ works best on desktops or tablets',
    modalMsg: 'Not all features are ready for mobile yet—but will be soon. For your best experience, please use another device to quote or manage policies on AMsuite+.',
  },
  remove: {
    modalTitle: 'Are you sure?',
    modalMsg: 'You\'re about to delete this username from your profile',
    modalSubtxt: 'Removing this username will remove it from your AMsuite+ account only. For questions about modification or termination of your agency appointment, please contact Producer Management at licensingandcontracts@amig.com.',
    modalSubtxt2: 'Click "Confirm" to continue or "Cancel" to change your mind.'
  },
  expire: {
    modalTitle: 'Session timeout',
    modalMsg: 'Due to inactivity, your session is about to expire',
  },
  reports: {
    modalMsg: 'Clicking \'Continue\' will open the reports tool in a new tab. When you\'re ready to return to AMsuite+, switch back to this tab.',
  },
  changeLoginId: {
    modalMsg: 'IMPORTANT: Changing your AMsuite+ Login ID (Email) doesn\'t change your login credentials for managed group sites. If you log in through partner sites, make sure your email on those sites matches your new AMsuite+ email.'
  },
};

export default types;